module.exports = __webpack_public_path__ + "img/card_ic_service.b76c6b4b.png";